import { api } from './api';
import { GaragePinCandidate, GaragePinsResponse } from '../types/garagePins';

/**
 * Spec 061 — admin-pinned garages (garages service, screen `dynamic-config`). The pinned garages
 * lead the customer app's Default ranking, in this order, on the next request after a save.
 */
export const garagePinsApi = {
  /** The pinned list, ordered by position, plus the limit and the bookable-only gate state. */
  list: (token: string) =>
    api.get<GaragePinsResponse>('/api/garages/admin/pins', token),

  /**
   * Replaces the whole list atomically (may be empty). **422** for a duplicate, more than 20 ids,
   * an unknown garage, or a newly added garage that is not approved or is blocked.
   */
  replace: (garageIds: string[], token: string) =>
    api.put<GaragePinsResponse>('/api/garages/admin/pins', { garageIds }, token),

  /** Up to 10 approved, unblocked, not-yet-pinned garages whose name matches `q`. */
  candidates: (q: string, token: string) =>
    api.get<GaragePinCandidate[]>(
      `/api/garages/admin/pins/candidates?q=${encodeURIComponent(q)}&limit=10`, token),
};
